export default function LondonBackdrop() {
  return (
    <div
      aria-hidden="true"
      data-testid="hero-london-backdrop"
      className="absolute inset-0 overflow-hidden pointer-events-none"
    >
      {/* Deep glow behind text */}
      <div className="absolute left-1/2 -translate-x-1/2 top-24 h-[520px] w-[900px] rounded-full bg-teal/10 blur-[140px]" />

      {/* Grid mask */}
      <div className="absolute inset-0 grid-bg opacity-40 [mask-image:radial-gradient(ellipse_at_center,black_35%,transparent_75%)]" />

      {/* Stars */}
      <div className="absolute inset-0">
        {STARS.map((s, i) => (
          <span
            key={i}
            className="london-star absolute rounded-full bg-white/60"
            style={{
              left: `${s.x}%`,
              top: `${s.y}%`,
              width: `${s.size}px`,
              height: `${s.size}px`,
              animationDelay: `${s.delay}s`,
              animationDuration: `${s.dur}s`,
            }}
          />
        ))}
      </div>

      {/* Drifting clouds */}
      <div className="absolute left-0 right-0 top-[22%] h-40 opacity-40">
        <div className="cloud cloud-a" />
        <div className="cloud cloud-b" />
        <div className="cloud cloud-c" />
      </div>

      {/* London skyline SVG */}
      <svg
        viewBox="0 0 1600 400"
        preserveAspectRatio="xMidYMax slice"
        className="absolute bottom-0 left-0 right-0 w-full h-[46%] md:h-[52%] pointer-events-none"
      >
        <defs>
          <linearGradient id="lg-sky" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0" stopColor="#050A0F" stopOpacity="0" />
            <stop offset="1" stopColor="#050A0F" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="lg-riv" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0" stopColor="#00d9b8" stopOpacity="0.2" />
            <stop offset="1" stopColor="#00d9b8" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Faint horizon */}
        <rect x="0" y="0" width="1600" height="400" fill="url(#lg-sky)" opacity="0.5" />

        {/* Distant hills */}
        <path
          d="M0 320 L120 300 L260 315 L400 295 L560 310 L720 288 L900 305 L1080 292 L1260 308 L1440 296 L1600 312 L1600 400 L0 400 Z"
          fill="#02171B"
          opacity="0.85"
        />

        {/* Distant tower cluster (Canary Wharf-ish) far right */}
        <g opacity="0.75" fill="#031A1F">
          <rect x="1250" y="220" width="26" height="120" />
          <rect x="1280" y="200" width="38" height="140" />
          <rect x="1322" y="240" width="22" height="100" />
          <rect x="1350" y="210" width="32" height="130" />
          <rect x="1386" y="245" width="20" height="95" />
        </g>

        {/* City hall / OXO tower cluster left */}
        <g opacity="0.85" fill="#04222A">
          <rect x="90" y="260" width="30" height="80" />
          <rect x="124" y="240" width="24" height="100" />
          <rect x="152" y="250" width="30" height="90" />
        </g>

        {/* Big Ben (main marker) */}
        <g fill="#052A31">
          <rect x="360" y="180" width="30" height="160" />
          <rect x="356" y="176" width="38" height="8" />
          <polygon points="356,176 394,176 375,140 " />
          <polygon points="365,140 385,140 375,110 " />
          {/* clock face */}
          <circle cx="375" cy="200" r="9" fill="#F2E9BC" />
          <line x1="375" y1="200" x2="375" y2="193" stroke="#052A31" strokeWidth="1.5" />
          <line x1="375" y1="200" x2="379" y2="200" stroke="#052A31" strokeWidth="1.5" />
        </g>

        {/* Parliament block */}
        <g fill="#04232B">
          <rect x="410" y="240" width="140" height="100" />
          <rect x="418" y="228" width="14" height="14" />
          <rect x="452" y="222" width="14" height="20" />
          <rect x="490" y="228" width="14" height="14" />
          <rect x="528" y="222" width="14" height="20" />
        </g>

        {/* London Eye */}
        <g stroke="#0A3D46" strokeWidth="2" fill="none">
          <circle cx="640" cy="220" r="66" />
          <circle cx="640" cy="220" r="52" strokeDasharray="3 3" opacity="0.6" />
        </g>
        <line x1="640" y1="286" x2="640" y2="340" stroke="#0A3D46" strokeWidth="4" />
        <g fill="#00E5C2">
          {[...Array(12)].map((_, i) => {
            const a = (i / 12) * Math.PI * 2;
            const cx = 640 + Math.cos(a) * 66;
            const cy = 220 + Math.sin(a) * 66;
            return <circle key={i} cx={cx} cy={cy} r="1.6" opacity="0.9" />;
          })}
        </g>

        {/* The Shard */}
        <g fill="#04252D">
          <polygon points="820,340 830,80 852,340 " />
        </g>
        <line x1="830" y1="80" x2="830" y2="60" stroke="#053039" strokeWidth="1.5" />

        {/* The Gherkin */}
        <g fill="#05282F">
          <ellipse cx="920" cy="200" rx="24" ry="88" />
          <rect x="912" y="260" width="16" height="80" />
        </g>

        {/* Cheesegrater */}
        <g fill="#032027">
          <polygon points="970,340 1010,140 1030,180 1030,340 " />
        </g>

        {/* Walkie Talkie */}
        <g fill="#04252C">
          <path d="M1060 340 L1060 200 Q1060 170 1092 170 L1104 170 Q1136 170 1136 205 L1136 340 Z" />
        </g>

        {/* Random office towers */}
        <g fill="#03222A">
          <rect x="220" y="270" width="24" height="70" />
          <rect x="248" y="258" width="30" height="82" />
          <rect x="702" y="272" width="26" height="68" />
          <rect x="732" y="258" width="22" height="82" />
          <rect x="1160" y="248" width="34" height="92" />
          <rect x="1196" y="270" width="24" height="70" />
        </g>

        {/* Window lights (blinking) */}
        {LIGHT_POINTS.map((p, i) => (
          <rect
            key={i}
            x={p.x}
            y={p.y}
            width="1.6"
            height="2"
            fill={p.teal ? "#00E5C2" : "#F0EAB6"}
            opacity={p.teal ? 0.9 : 0.7}
            className="light-blink"
            style={{ animationDelay: `${p.delay}s`, animationDuration: `${p.dur}s` }}
          />
        ))}

        {/* Thames river reflection line */}
        <rect x="0" y="340" width="1600" height="60" fill="url(#lg-riv)" opacity="0.6" />
      </svg>

      <style>{`
        .london-star {
          box-shadow: 0 0 6px rgba(255,255,255,0.4);
          animation: twinkle 3.6s ease-in-out infinite;
        }
        @keyframes twinkle {
          0%, 100% { opacity: 0.25; transform: scale(0.8); }
          50% { opacity: 0.9; transform: scale(1); }
        }
        .cloud {
          position: absolute;
          height: 26px;
          border-radius: 999px;
          background: linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.14), rgba(255,255,255,0.06));
          filter: blur(6px);
          animation: drift 60s linear infinite;
        }
        .cloud-a { top: 20%; left: -30%; width: 30%; animation-duration: 90s; }
        .cloud-b { top: 55%; left: -55%; width: 42%; animation-duration: 110s; animation-delay: -30s; opacity: 0.7; }
        .cloud-c { top: 80%; left: -80%; width: 25%; animation-duration: 75s; animation-delay: -55s; opacity: 0.5; }
        @keyframes drift {
          0% { transform: translateX(0); }
          100% { transform: translateX(220vw); }
        }
        .light-blink {
          animation: blink 4s ease-in-out infinite;
        }
        @keyframes blink {
          0%, 40%, 100% { opacity: 0.15; }
          20% { opacity: 1; }
        }
      `}</style>
    </div>
  );
}

// Deterministic stars & lights so no hydration issues
const STARS = Array.from({ length: 34 }, (_, i) => {
  const s = (i * 9301 + 49297) % 233280;
  const r = s / 233280;
  return {
    x: (i * 137.5 + r * 40) % 100,
    y: 5 + ((i * 43 + r * 90) % 40),
    size: 1 + (i % 3) * 0.6,
    delay: (r * 4).toFixed(2),
    dur: 2.5 + (i % 4),
  };
});

const LIGHT_POINTS = (() => {
  const rows = [
    // parliament
    { xs: [415, 425, 435, 445, 460, 470, 490, 500, 510, 520, 535, 545], y: 260, teal: false },
    { xs: [415, 425, 435, 445, 460, 470, 490, 500, 510, 520, 535, 545], y: 280, teal: false },
    { xs: [415, 425, 435, 445, 460, 470, 490, 500, 510, 520, 535, 545], y: 305, teal: false },
    // shard
    { xs: [828, 830, 832, 834, 836, 838], y: 140, teal: true },
    { xs: [826, 830, 834, 838], y: 180, teal: false },
    { xs: [824, 828, 832, 836, 840], y: 220, teal: false },
    { xs: [822, 826, 830, 834, 838, 842], y: 260, teal: false },
    { xs: [820, 824, 828, 832, 836, 840, 844], y: 300, teal: false },
    // gherkin
    { xs: [906, 910, 914, 918, 922, 926, 930, 934], y: 210, teal: false },
    { xs: [906, 910, 914, 918, 922, 926, 930, 934], y: 240, teal: true },
    { xs: [910, 914, 918, 922, 926, 930], y: 270, teal: false },
    // canary
    { xs: [1252, 1258, 1264, 1270, 1288, 1298, 1308, 1322, 1330, 1352, 1362, 1372, 1390, 1398], y: 250, teal: false },
    { xs: [1252, 1258, 1264, 1270, 1288, 1298, 1308, 1322, 1330, 1352, 1362, 1372, 1390, 1398], y: 285, teal: true },
    { xs: [1252, 1258, 1264, 1270, 1288, 1298, 1308, 1322, 1330, 1352, 1362, 1372, 1390, 1398], y: 315, teal: false },
  ];
  const out = [];
  let k = 0;
  rows.forEach((r) => {
    r.xs.forEach((x) => {
      const delay = ((k * 137) % 400) / 100;
      const dur = 3 + (k % 4);
      out.push({ x, y: r.y, teal: r.teal, delay, dur });
      k++;
    });
  });
  return out;
})();
